import { SubsectionBuffers } from '../../components/gantt/gantt/ganttHelper';
import { Contract } from './contracts.types';

export const getContractFromRoleId = (contracts: Contract[], roleId: string) => {
  const contract = contracts.find(c => {
    return Boolean(c.roles?.find(r => r.id === roleId));
  });

  return contract;
};

export const getContractById = (id: string, contracts: Contract[]) => {
  const contract = contracts.find(c => c.id === id);

  if (!contract && id) throw new Error(`Missing contract with id ${id}`);

  return contract;
};

export const findContractById = (contracts: Contract[], id?: string) => (id ? contracts.find(c => c.id === id) : undefined);

// Break placement buffers of a shift come from its employee's contract; without an employee there are none.
export const getBreakBuffers = (employeeContract?: Contract): SubsectionBuffers => ({
  startBuffer: employeeContract?.minMinutesBeforeBreak ?? 0,
  endBuffer: employeeContract?.minMinutesAfterBreak ?? 0
});
